import { render, staticRenderFns } from "./RealBalanceLogs.vue?vue&type=template&id=a8288074"
import script from "./RealBalanceLogs.vue?vue&type=script&lang=ts"
export * from "./RealBalanceLogs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports